module.exports = __webpack_public_path__ + "static/media/itemdisable.25cdaf37.png";